import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    wrapper: {
        overflowY: 'scroll',
        height: '100%',
        padding: '16px 0 10px',
    },
    header: {
        padding: '8px 12px',
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 12,
        lineHeight: 1.5,
        color: '#b8bfca',
        marginBottom: 0,
    },
    title: {
        color: theme.colors.white,
        letterSpacing: '-0.35px',
        marginBottom: 8,
        padding: '8px 12px',
        fontSize: 14,
    },
    buttonWrapper: {
        position: 'fixed',
        bottom: 10,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        zIndex: theme.zIndexLevels.two,

        '@media (min-width: 768px)': {
            width: 320,
        },

        '@media (min-width: 1024px)': {
            width: 400,
        },
    },
    submitBtn: {
        width: 'calc(100% - 32px)',
    },
}))
